import { BillingCallbackTemplate } from "@/components/Templates";
import { type BillingCallbackStatus, useBillingCallbackPage } from "@/hooks/useBillingCallbackPage";

type BillingCallbackPageProps = {
  status: BillingCallbackStatus;
};

export function BillingCallbackPage({ status }: BillingCallbackPageProps) {
  const callback = useBillingCallbackPage(status);

  return <BillingCallbackTemplate {...callback} />;
}
